import styled from 'styled-components';
import Link from 'syf-component-library/ui/atoms/Link';
import { fontWeights } from 'syf-component-library/defaultTheme';
const DebtCancellationLinkContainer = styled(Link) `
  font-weight: ${fontWeights.bold};
`;
export default DebtCancellationLinkContainer;
